<template>
  <div class="order-item">
    <!-- 顾客新订单标签 -->
    <img
      v-if="!isAdmin && order.is_new_order"
      class="customer-new-tag"
      src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/price/icon-order-new.png"
      alt=""
    />

    <div class="order-title">
      <div class="title-num">{{order.user_order_id}}</div>
      <div class="title-name">{{order.product_name}}</div>
      <div class="title-right">
        <div class="title-status" :class="calculateOrderStatusClass(order, 1)">
          {{ $maps.ORDER_STATUS[order.order_status] }}
        </div>

        <order-invoice-tag :order="order"></order-invoice-tag>

        <button-more
          class="m-r-30"
          :order="order"
          :order-list="orderList"
          :index="index"
          :is-admin="isAdmin"
        ></button-more>
        <!-- 普通订单 -->
        <template v-if="!order.enable_api">
          <el-button
            type="default"
            v-if="
              (order.order_status > 0 && order.order_status < 4) ||
                order.order_status === 10
            "
            @click="cancelOrder(order)"
            >取消订单</el-button
          >

          <el-button
            type="default"
            v-if="order.order_status === 0"
            @click="deleteOrder(order, index)"
            >删除订单</el-button
          >

          <a
            class="el-button el-button--primary"
            v-if="order.order_status == 1"
            @click="goBuyingForMta(order)"
            >上传资料</a
          >

          <a
            class="el-button el-button--primary"
            v-if="order.order_status == 2"
            @click="goBuyingForMta(order)"
            >填写申请表</a
          >

          <a
            class="el-button el-button--primary"
            v-if="order.order_status == 3"
            @click="goBuyingForMta(order)"
            >立即支付</a
          >

          <a
            class="el-button el-button--primary"
            v-if="order.order_status == 10"
            @click="goBuyingForMta(order)"
            >选择赴馆日期</a
          >

          <el-button
            type="default"
            v-if="order.need_review"
            @click="goToEvaluate(order)"
            >服务评价</el-button
          >

          <!-- 以上是支付前的状态，以下是支付后的状态 -->
          <a
            class="el-button el-button--danger"
            v-if="order.need_pay_price_diff === 1"
            @click="goToOrderDiffPay(order)"
            >补缴费用</a
          >

          <el-button
            type="danger"
            @click="delivery(order)"
            v-if="
              order.visa_supplier_id !== 0 &&
                order.order_status === 4 &&
                (!order.pickup_status || order.pickup_status === 0) &&
                order.need_pay_price_diff !== 1
            "
            >寄送资料</el-button
          >

          <a
            class="el-button el-button--primary"
            v-if="order.order_status > 3 && order.order_status !== 10"
            @click="goOrderDetail(order)"
            >查看订单</a
          >

          <a
            class="el-button el-button--primary"
            v-if="order.apply_by"
            @click="reOrder(order)"
            >重新预约缴费</a
          >
        </template>
        <!-- API订单 -->
        <template v-else>
          <a
            class="el-button el-button--primary"
            v-if="order.order_status > 3 && order.order_status !== 10"
            @click="goOrderDetail(order)"
            >查看订单</a
          >
        </template>

        
      </div>
    </div>

    <!-- 申请人 -->
    <div class="order-applicant-box">
      <div v-if="order.peer_user && order.peer_user.mobile_phone" class="user-phone">
        <img class="icon" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/price/icon-phone.png" alt="">
        <div class="user-phone-label">顾客联系方式：</div>
        <base-text-copy :text="order.peer_user.mobile_phone"></base-text-copy>
      </div>
      <!-- 申请人 -->
      <template v-for="(ins, ind) in order.applicant">
        <div class="insurant-list" :class="{'no-bottom-border': (ind === order.applicant.length - 1) || (!collapsed && ind === 2)}" v-if="collapsed || ind < 3" :key="ind">
          <div class="insurant-list-left">
            <div class="insurant-name-code-box">
              <div class="insurant-name" >{{ins.applicant_name}}</div>
              <div class="insurant-code">{{ins.identity}}</div>
            </div>
            <div class="insurant-status" :class="calculateApplicantStatusClass(ins, 1)">{{order.pay_time?$maps.APPLICANT_STATUS[ins.applicant_status]:''}}</div>
            
          </div>
        </div>
      </template>
        <!-- 是否展开 -->
      <expand :default-length="3" :max-length="order.applicant.length" @expanded="x => (collapsed = x)" />
    </div>

    <!-- 底部信息 -->
    <div class="list-bottom" v-if="order.pay_time || order.ota_info || isAdmin">
      <div class="bottom-info-item" v-if="order.ota_info">
        <fliggy-order-info-bar :ota-info="order.ota_info"></fliggy-order-info-bar>
      </div>

      <div class="bottom-info-item" v-if="isAdmin">
        <span>负责成员：</span>
        <span class="account-name">
          {{ order.peer_account_name }}
        </span>
      </div>

      <div class="bottom-info-item" v-if="order.pay_time && [0,1].indexOf(order.visa_status) > -1">
        <div class="visa-date" v-if="order.visa_status === 0">
          <span class="info-item-label">预计出签：</span>

          <span v-if="!order.visa_date">
            {{order.need_delivery > 0 || order.need_interview > 0 ? '预约成功后即可预估出签时间' : '送签后即可预估出签时间'}}
          </span>
          <span class="schedule-date-toggle" v-else>
            {{order.visa_date}}{{ order.visa_date_longest && order.visa_date !== order.visa_date_longest ? `~${order.visa_date_longest}` : '' }}
          </span>
        </div>
        <div class="visa-date" v-if="order.visa_status === 1">
          <div class="schedule-item-date">
            <span class="schedule-date-text">出签时间：</span>
            <span class="schedule-date-toggle">
              {{order.visa_date}}
            </span>
          </div>
        </div>
      </div>

      <div class="bottom-info-item" v-if="order.pay_time">
        <span>支付时间：</span>
        <span>
          {{order.pay_time ? order.pay_time : '未支付'}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import dateUtils from '../libs/date-util';
import orderService from '../services/order-service';
import expand from './common/expand';
import utils from '../libs/utils';
import Http from '../libs/http';

import ButtonMore from '../pages/ordering/components/button-more.vue';
import OrderInvoiceTag from './order-list/order-invoice-tag.vue';
import BaseTextCopy from '@/components/common/base-text-copy.vue';

export default {
  name: 'orderItem',
  props: {
    order: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    orderList: {
      type: Array,
      default() {
        return [];
      },
    },
    index: {
      type: Number,
      default: 0, 
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapsed: false,
    };
  },
  components: {
    expand,
    ButtonMore,
    OrderInvoiceTag,
    BaseTextCopy,
  },
  methods: {
    getPayTime(payTime) {
      return payTime ? moment(payTime).format('YYYY年MM月DD日') : '未支付';
    },

    formatDateWithoutYear: dateUtils.formatDateWithoutYear,
    // 计算订单状态的样式
    calculateOrderStatusClass: orderService.calculateOrderStatusClass,
    // 计算申请人状态的样式
    calculateApplicantStatusClass: orderService.calculateApplicantStatusClass,

    // 取消订单
    cancelOrder(od) {
      this.$emit('cancel-order', od);
    },
    // 删除订单
    deleteOrder(order) {
      utils.msgbox
        .confirm('确定删除该订单？', '删除订单', {
          confirmButtonText: '　确定　',
          cancelButtonText: ' 取消 ',
          type: 'warning',
        })
        .then(() => {
          Http.post('/order_delete', {
            user_order_id: order.user_order_id,
          }).then(() => {
            this.$emit('refresh');
          }).catch((e) => {
            if (e) console.log(e);
          });
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    // 根据不同状态到下单界面 同时加入埋点
    goBuyingForMta(item) {
      if (item.order_status === 1) {
        this.$router.push({
          name: 'waittingForUpload',
          params: {
            oid: item.user_order_id,
          },
        });
      }
      if (item.order_status === 2) {
        this.$router.push({
          name: 'waittingForUpload',
          params: {
            oid: item.user_order_id,
          },
        });
      }
      if (item.order_status === 3) {
        this.$router.push({
          name: 'orderComfirm',
          params: {
            oid: item.user_order_id,
          },
        });
      }
      if (item.order_status === 10) {
        this.$router.push({
          name: 'waittingForChooseInterviewTime',
          params: {
            oid: item.user_order_id,
          },
        });
      }
    },
    // 去到订单评价界面
    goToEvaluate(item) {
      this.$router.push({
        name: 'orderEvaluation',
        params: {
          oid: item.user_order_id,
        },
      });
    },
    // 到补缴费用界面
    goToOrderDiffPay(item) {

      this.$router.push({
        name: 'orderDiffPay',
        params: {
          oid: item.user_order_id,
        },
      });
    },

    delivery(od) {
      orderService.pickUpCheck(od.user_order_id).then(() => {
        this.$emit('delivery', od);
      });
    },

    // 到订单详细界面
    goOrderDetail(order) {
      this.$router.push({
        name: 'orderDetail',
        params: { oid: order.user_order_id },
      });
    },

    // 跳转至重新预约缴费页面
    reOrder(order) {
      // 获取重新预约缴费的申请人的订单id数组
      const applicantIdsToChange = order.applicant
        .filter(item => item.interview_status === 2)
        .map(item => item.order_applicant_id);
      this.$router.push({
        name: 'reOrderPay',
        params: { oid: order.user_order_id },
        // 传递申请人数组（先转化为string）
        query: {
          aidArray: JSON.stringify(applicantIdsToChange),
          updateDateType: 2, // 1为修改赴馆时间，2为重新预约缴费
        },
      });
    },

  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/variable";
.order-item {
  border: 1px #f0f0f0 solid;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.08);
  font-size: 16px;
  margin-bottom: 24px;
  border-radius: 4px;
  position: relative;
  .customer-new-tag{
    width: 65px;
    height: 40px;
    position: absolute;
    top: -14px;
    left: -11px;
  }
  .order-title {
    display: flex;
    align-items: center;
    height: 56px;
    border-bottom: 1px solid @border;
    padding-left: 20px;
    justify-content: space-between;
    .title-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-shrink: 0;
      > button,
      > span,
      > a {
        /* margin-left: 20px; */
        margin: 0 14px 0 0;
        padding: 0 12px;
        line-height: 28px;
        text-align: center;
        height: 30px;
      }
    }
    .title-num {
      padding: 0 12px;
      height: 30px;
      background-color: @bg;
      line-height: 30px;
      font-size: 14px;
      color: @text-sliver;
      text-align: center;
      margin-right: 15px;
      border-radius: 4px;
    }
    .title-name {
      color: @text-dark;
      font-weight: bold;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      flex: 1;
      padding-right: 100px;
    }
    .title-status {
      margin-right: 40px;
      flex-shrink: 0;
      padding-left: 24px;
      position: relative;
      font-size: 14px;
      color: @text-dark;
      &::before {
        content: '';
        position: absolute;
        left: 0px;
        top: 0px;
        width: 14px;
        height: 14px;
        background: url(../assets/imgs/insurance/status-common.png) center
          center no-repeat;
      }
      &.gray-plane {
        color: @text-aaa;
        &::before {
          background: url(../assets/imgs/insurance/status-cancel.png) center
            center no-repeat;
        }
      }
      &.red-plane {
        color: @text-red;
        &::before {
          background: url(../assets/imgs/insurance/status-process.png)
            center center no-repeat;
        }
      }
    }
  }

  .list-bottom {
    height: 40px;
    background-color: @active;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: @text-aaa;
    padding: 0 20px;
    .bottom-info-item{
      border-right: 1px solid #F0F0F0;
      display: flex;
      align-items: center;
      &:first-child{
        padding-left: 0;
      }
      &:last-child{
        border-right: none;
      }
    }
  }

  .list-expand {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    margin-bottom: 20px;

    .expand-line {
      height: 1px;
      background-color: @border;
      width: 50%;
    }
    .expand-content {
      cursor: pointer;
      flex-shrink: 0;
      margin: 0 20px;
      padding-right: 22px;
      position: relative;
      font-size: 14px;
      color: @text-sliver;
      span {
        color: @blue;
      }
      &.is-expand {
        &::after {
          transform: rotate(180deg);
        }
      }
      &::after {
        content: '';
        position: absolute;
        right: 0px;
        top: 0px;
        width: 16px;
        height: 16px;
        background: url(../assets/imgs/insurance/insurance-expend-all.png)
          center center no-repeat;
      }
    }
  }

  .order-applicant-box{
    position: relative;
    .user-phone{
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #5F666E;
      font-size: 12px;
      line-height: 1;
      width: 300px;
      height: 24px;
      background: linear-gradient( 270deg, rgba(89,159,255,0.08) 0%, rgba(89,159,255,0) 100%);
      padding: 0 20px;
      .icon{
        width: 12px;
        height: 12px;
        margin-right: 4px;
      }
      .user-phone-user{
        cursor: pointer;
        &:hover{
          color: #5E9BE2;
        }
      }
    }
  }

  .insurant-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 20px 0 40px;
    border-bottom: 1px dashed @border;
    .insurant-list-left{
      margin: 0 auto;
      height: 76px;
      width: 880px;
      display: flex;
      align-items: center;

      font-size: 16px;
      color: @text-dark;
    }
    &.no-bottom-border {
      border-bottom-color: transparent;
    }
    .insurant-name-code-box{
      width: 350px;
      display: flex;
      align-items: center;
    }
    .insurant-name {
      flex-shrink: 0;
      min-width: 100px;
      max-width: 100px;
      margin-right: 50px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .insurant-code {
      width: 100px;
      // margin-right: 100px;
      color: @text-aaa;
    }
    .insurant-status {
      &.status-red {
        color: @text-red;
      }
      &.status-gray {
        color: @text-aaa;
      }
    }
    .insurant-visa-date{
      margin-left: 8px;
      padding-left: 8px;
      height: 20px;
      border-left: 1px solid #F0F0F0;
      color: #aaa;
      font-size: 14px;
      display: flex;
      align-items: center;
      line-height: 1;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/order-item.vue